<div ngbDropdown class="vox-dropdown-input">
  <button type="button" ngbDropdownToggle>{{'common.' + selectedCompanyAssociated | translate}}</button>
  <div ngbDropdownMenu>
    <button type="button" ngbDropdownItem *ngFor="let value of COMPANY_ASSOCIATED"
      (click)="selectCompanyAssociated(value)">{{'common.' + value | translate}}</button>
  </div>
</div>